<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('common.status') }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 lg6>
        <v-form ref="customerForm">
          <v-text-field
              v-if="fetched || !!this.$route.params.id"
              v-model="status"
              outlined
              :rules="[(v) => !!v || $t('form.validationErrors.field_is_required'), (v) => (!!v) || $t('form.validationErrors.must_be_greater', [0])]"
              :value="status"
              :label="$t('common.title')"
          ></v-text-field>
          <v-menu offset-y class="pb-3">
            <template v-slot:activator="{ on }">
              <v-btn
                  :loading="!fetched && !!Number($route.params.id)"
                  :style="{color:contrastColor}"
                  rounded-sm
                  elevation="0"
                  :color="color"
                  dark
                  v-on="on"
              >
                {{ $t('viewSettings.statuses.color') }}
              </v-btn>
            </template>
            <v-color-picker
                value="#7417BE"
                v-model="color"
                hide-canvas
                hide-inputs
                show-swatches
                class="mx-auto"
            ></v-color-picker>
          </v-menu>
          <v-divider class="mt-5"></v-divider>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="$router.push({name: 'settings-statuses'});"
              @keyup.enter="$router.push({name: 'settings-statuses'});"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5"
              color="primary"
              elevation="0"
              @click="submit"
              @keyup.enter="submit"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import {required, email, sameAs, minLength,} from "vuelidate/lib/validators";
import {mapState} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import CommonMixin from "@/mixins/common";

export default {
  mixins: [CommonMixin],
  data: () => ({
    emptyStatus: {
      name: '',
      color: '#32CD32',
    },
    statusType: null,
    types: {
      'order': 'order_statuses',
      'part': 'order_parts_statuses',
      'repairtime': 'order_repairtimes_statuses',
      'bid': 'bid_stages'
    }
  }),
  created() {
    this.onLoad();
  },

  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  computed: {
    ...mapFields('statuses', [
      'fetched',
      'savingInProgress',
      'order_statuses',
      'bid_stages',
      'order_parts_statuses',
      'order_repairtimes_statuses',
    ]),
    contrastColor() {
      return this.getCorrectTextColor(this.color);
      //return this.color;
    },
    status: {
      // getter
      get: function () {
        this
        if (this.$route.params.id > 0 && this.fetched) {
          return this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true)[0] && this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true)[0].name
        } else {
          return this.emptyStatus.name;
        }
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let status = this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true)
          status[0].name = newValue;
        } else {
          this.emptyStatus.name = newValue;
        }
      }
    },
    color: {
      // getter
      get: function () {
        if (this.$route.params.id > 0 && this.fetched) {
          return this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true)[0] && this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true )[0].color
        } else {
          return this.emptyStatus.color;
        }
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let status = this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true)
          status[0].color = newValue;
        } else {
          this.emptyStatus.color = newValue;
        }
      }
    }
  },
  methods: {
    onLoad() {
      switch (this.$route.name) {
        case 'settings-order-statuses-edit':
        case 'settings-order-statuses-create':
          this.statusType = 'order';
          break;
        case 'settings-order-part-statuses-edit':
        case 'settings-order-part-statuses-create':
          this.statusType = 'part';
          break;
        case 'settings-order-repairtime-statuses-edit':
        case 'settings-order-repairtime-statuses-create':
          this.statusType = 'repairtime';
          break;
        case 'settings-order-bid-statuses-edit':
        case 'settings-order-bid-statuses-create':
          this.statusType = 'bid';
          break;
      }
      if (this.$route.params.id > 0) {
        this.$store.dispatch('statuses/statusesGet').then(() => {

          if (!this[this.types[this.statusType]].filter(status => Number(status.id) === Number(this.$route.params.id) && status.system !== true) ) {
            this.$router.push({name: '404'})
          }
        });
      }
    },
    submit() {
      if (this.$refs['customerForm'].validate()) {
        let type;
        switch (this.statusType) {
          case 'order':
            type = 'shop_order_status'
            break;
          case 'part':
            type = 'shop_order_part_status'
            break;
          case 'repairtime':
            type = 'shop_order_repairtime_status'
            break;
          case 'bid':
            type = 'bid_stage'
            break;
        }
        if (this.$route.params.id) {
          this.$store.dispatch('statuses/shopStatusUpdate', {
            id: this.$route.params.id,
            type: type
          }).then((result) => {
              if(result) this.$router.push({name: 'settings-statuses'});
          })
        } else {
          this.$store.dispatch('statuses/shopStatusStore', {status: this.emptyStatus, type: type}).then((id) => {
            if (id > 0) {
              this.$router.push({name: 'settings-statuses'});
            }
          })
        }
      }
    }
  },
}
</script>